import { render, staticRenderFns } from "./RequestButtonCreate.vue?vue&type=template&id=39eb190a&scoped=true"
import script from "@/components/request/RequestButtonCreate/RequestButtonCreate.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestButtonCreate/RequestButtonCreate.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestButtonCreate/request-button-create.scss?vue&type=style&index=0&id=39eb190a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eb190a",
  null
  
)

export default component.exports